
const updateVersion = <T extends string | number>(version: T): string => {
    const major = parseInt(version.toString().split('.')[0], 10);
    return `${major + 1}.0`;
};

export {
    updateVersion
};
